import Login from "@panel/auth/login";
import LoginCallback from "@panel/auth/login/callback";

const AuthenticationRoutes = [
  {
    path   : "/login",
    element: <Login />,
    meta   : {
      layout     : "blank",
      restricted : true,
      title      : "Nookpay Login",
      publicRoute: true
    }
  },
  {
    path   : "/login/callback",
    element: <LoginCallback />,
    meta   : {
      layout     : "blank",
      title      : "Signing in…",
      publicRoute: true
    }
  }
];

export default AuthenticationRoutes;
